// Third-party brand marks, sourced from simple-icons so every glyph shares one
// 24-grid and we never hand-trace a trademark. Rendered through BrandMark.vue.
// Ported from GAMZOR (GamingForge) utils/brand-icons.ts.
import {
  siApplepay,
  siBitcoin,
  siBluesky,
  siDiscord,
  siFacebook,
  siGithub,
  siGooglepay,
  siInstagram,
  siKick,
  siReddit,
  siSteam,
  siTelegram,
  siThreads,
  siTiktok,
  siTwitch,
  siWhatsapp,
  siX,
  siYoutube,
  siKlarna,
  siMastercard,
  siPaypal,
  siRevolut,
  siStripe,
  siVisa,
  type SimpleIcon,
} from 'simple-icons';

// Social platforms as the CMS stores them (`GET /cms/social-links`), in the
// order the admin icon picker offers them. Keys are lower-cased before
// lookup. LinkedIn has no simple-icons glyph (trademark removal) and falls
// back to a text chip — a stored "linkedin" row keeps working.
export const SOCIAL_ICONS: Record<string, SimpleIcon> = {
  x: siX,
  twitter: siX,
  discord: siDiscord,
  telegram: siTelegram,
  instagram: siInstagram,
  facebook: siFacebook,
  youtube: siYoutube,
  tiktok: siTiktok,
  twitch: siTwitch,
  kick: siKick,
  reddit: siReddit,
  steam: siSteam,
  whatsapp: siWhatsapp,
  threads: siThreads,
  bluesky: siBluesky,
  github: siGithub,
};

export function socialIcon(platform: string): SimpleIcon | null {
  return SOCIAL_ICONS[platform.toLowerCase()] ?? null;
}

// Payment rails as the admin names them (`GET /cms/payment-methods` slugs).
// Rails without a simple-icons glyph (bank transfer, Skrill, iDEAL, Sofort,
// Giropay, Paysafecard) render as a name chip; custom rails may carry their
// own `icon` URL.
const PAYMENT: Record<string, SimpleIcon> = {
  visa: siVisa,
  mastercard: siMastercard,
  paypal: siPaypal,
  crypto: siBitcoin,
  'apple-pay': siApplepay,
  'google-pay': siGooglepay,
  klarna: siKlarna,
  revolut: siRevolut,
  stripe: siStripe,
};

export function paymentIcon(slug: string): SimpleIcon | null {
  return PAYMENT[slug.toLowerCase()] ?? null;
}
